import axios from "axios";
import { getCurrentUser } from "../utils/currentUser";

const API = axios.create({

    baseURL:
        process.env.REACT_APP_API_URL ||

        "https://localhost:7172/api"
});

API.interceptors.request.use(

    (config) => {

        const user = getCurrentUser();

        if (user?.username) {

            config.headers["X-Username"] =
                user.username;
        }

        return config;
    },

    (error) => {

        return Promise.reject(error);
    }
);

export default API;